"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WINDOW_CLOSED = exports.PAGE_VIEW = exports.PAGE_SCROLL = exports.COMPONENT_IMPRESSION = exports.COMPONENT_ACTION = void 0;
var COMPONENT_ACTION = 'componentAction';
exports.COMPONENT_ACTION = COMPONENT_ACTION;
var COMPONENT_IMPRESSION = 'componentImpression';
exports.COMPONENT_IMPRESSION = COMPONENT_IMPRESSION;
var PAGE_SCROLL = 'pageScroll';
exports.PAGE_SCROLL = PAGE_SCROLL;
var PAGE_VIEW = 'pageView';
exports.PAGE_VIEW = PAGE_VIEW;
var WINDOW_CLOSED = 'windowClosed';
exports.WINDOW_CLOSED = WINDOW_CLOSED;